import { render, staticRenderFns } from "./shipping-details.vue?vue&type=template&id=a1d799cc&scoped=true&"
import script from "./shipping-details.vue?vue&type=script&lang=js&"
export * from "./shipping-details.vue?vue&type=script&lang=js&"
import style0 from "./shipping-details.vue?vue&type=style&index=0&id=a1d799cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d799cc",
  null
  
)

export default component.exports